import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Panel } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import List from 'components/List';
import ClientRolesHoldingAccess from './ClientRolesHoldingAccess';
import may from "js/security";

class ClientRoles extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      originRoleSet: null,
      changed: false,
      showPrice: null,
    };
  }

  isChecked = role => {
    const { entity } = this.props;
    const roles = entity.getRoles();
    return roles.includes(role);
  };

  checkDisabled = () => {
    const { disabled } = this.props;
    return !!disabled;
  };

  onChange = e => {
    const { target } = e;
    const { checked, value: role } = target;
    const { entity, changeEntity } = this.props;

    let newValue;
    if (checked) {
      newValue = [...entity.getRoles(), role];
    } else {
      newValue = entity.getRoles().filter(r => r !== role);
    }

    const newEntity = { ...entity.updateValue('roles', newValue) };
    changeEntity(newEntity);
  };

  changeSet = id => {
    const { originRoleSet } = this.state;
    const { entity, changeEntity, roles } = this.props;
    let checkOriginal = false;
    const roleSet = roles.data.sets.find(({ id: setId }) => setId === id); // set id is a string
    if (roleSet) {
      const newValue = roleSet.user_roles;

      if (originRoleSet === null) {
        this.setState({ originRoleSet: entity.getRoles() });
      } else {
        checkOriginal = originRoleSet.every(val => newValue.includes(val)); // check if the already saved value is again selected, then we don't need to show payment info
      }
      if (checkOriginal) {
        this.setState({ changed: false, showPrice: null });
      } else {
        this.setState({ changed: true, showPrice: roleSet.pricePerUser });
      }
      const newEntity = { ...entity.updateValue('roles', newValue, []) };
      changeEntity(newEntity);
    }
  };

  render() {
    const { changed, showPrice } = this.state;
    const {
      intl: { messages },
      changeEntity,
      entityLoaded,
      parent,
      roles,
      // inModal,
      entity,
      user,
    } = this.props;

    let userRoles;
    if (!roles.pending && entityLoaded) {
      userRoles = entity.getRoles();
    }
    return (
      <div class="clearfix">
        <List noRender listName="roles" url="/api/roles.json" list={roles} />
        {entityLoaded && (
          <Row>
            <Col xs={12}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  {may('ROLE_ROOT_EMPLOYEE', user.roles) && (
                    <h2>
                      {messages.formGroup.subscription_roles}
                      {roles.pending && <i class="m-l-10 fa fa-circle-notch fa-spin" />}
                    </h2>
                  )}
                  <div>
                    {!roles.pending && may('ROLE_ROOT_EMPLOYEE', user.roles) && (
                      <Row className="user-role-select">
                        {roles.data.sets.map(roleSet => {
                          const { user_roles: roles } = roleSet;
                          const hasAllRoles = roles.every(role => userRoles.includes(role));
                          const className = hasAllRoles ? 'active' : '';

                          return (
                            <Col xs={4} md={3} key={roleSet.id}>
                              <Panel
                                onClick={() => {
                                  this.changeSet(roleSet.id);
                                }}
                                className={className}
                              >
                                <Panel.Heading>
                                  <Panel.Title componentClass="h3">{roleSet.name}</Panel.Title>
                                </Panel.Heading>
                                <Panel.Body>
                                  {/* TODO: add multi-language support */}
                                  <div dangerouslySetInnerHTML={{ __html: roleSet.description.de }} />
                                </Panel.Body>
                                <Panel.Footer>
                                  {roleSet.pricePerUser ? roleSet.pricePerUser + ' €, monatlich' : 'kostenfrei'}
                                </Panel.Footer>
                              </Panel>
                            </Col>
                          );
                        })}
                      </Row>
                    )}
                    {changed && showPrice && (
                      <>
                        <label>
                          Die monatlichen Nutzergebühren betragen <b>{showPrice}</b> Euro für diese Einstellung.
                        </label>
                        <br />
                        <br />
                        <input
                          disabled={this.checkDisabled()}
                          ref={ref => {
                            this.priceAck = ref;
                          }}
                          id="priceAck"
                          name="priceAck"
                          type="checkbox"
                          value="acknowledged"
                          required
                          onInvalid={() => {
                            this.priceAck.setCustomValidity('Bitte bestätigen Sie die Abo-Änderung!');
                          }}
                          onChange={() => {
                            if (this.priceAck.checked) {
                              this.priceAck.setCustomValidity('');
                            }
                          }}
                        />{' '}
                        <label htmlFor="priceAck">
                          {' Verstanden, bitte den Nutzer zum Preis von ' + showPrice + ' Euro monatlich, anlegen.'}
                        </label>
                      </>
                    )}
                    <Row>
                      {may('ROLE_ROOT_EMPLOYEE', user.roles) && (
                        <Col xs={12} md={6}>
                          <h2>{messages.formGroup.user_roles}</h2>
                          <div style={{ columnCount: '2', columnGap: '30px' }}>
                            {roles.data.list.map(role => {
                              const id = 'client-role-' + role;
                              return (
                                <div class="checkbox check-success" key={role}>
                                  <input
                                    disabled={this.checkDisabled()}
                                    id={id}
                                    name="roles[]"
                                    type="checkbox"
                                    value={role}
                                    checked={this.isChecked(role)}
                                    onChange={this.onChange}
                                  />{' '}
                                  <label htmlFor={id}>{role}</label>
                                </div>
                              );
                            })}
                          </div>
                        </Col>
                      )}
                      <Col xs={12} md={6}>
                        <ClientRolesHoldingAccess
                          entity={entity}
                          parent={parent}
                          changeEntity={changeEntity}
                          user={user}
                          disabled={this.checkDisabled()}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}
ClientRoles.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    roles: state.list.roles,
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(ClientRoles));
